export enum Periodicity {
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  YTD = 'Year to Date',
  MAT = 'Moving Annual Total',
  RollingQuarter = 'Rolling Quarter',
  CalendarQuarter = 'Calendar Quarter',
  Custom = 'Custom Period',
  CustomMonths = 'Custom months',
  CustomWeeks = 'Custom weeks',
}

export enum PeriodicityKey {
  Weekly = 'weekly',
  Monthly = 'monthly',
  YTD = 'YTD',
  MAT = 'MAT',
  RollingQuarter = 'rollingQuarter',
  CalendarQuarter = 'calendarQuarter',
  Custom = 'customPeriod',
  CustomMonths = 'customMonths',
  CustomWeeks = 'customWeeks',
}

export interface Period {
  /**
   * Weekly or Monthly
   */
  periodicity: Periodicity;

  /**
   * Sequence number (week or month number) since Unix Epoch (1970)
   */
  periodSequence: number;

  /**
   * The year this period is in
   */
  year?: number;

  /**
   * Week number in year or month number in year
   */
  positionInYear?: number;

  /**
   * First day of the period
   */
  startDate: Date;

  /**
   * Last day of the period
   */
  endDate: Date;

  /**
   * Data last updated date
   */
  lastUpdatedDate: number;
}
